import React, { useEffect } from "react";

import Page from "../../components/general/page";
import { getCustomersList } from "../../store/actions/customers";
import CustomersList from "../../components/dashboard/customersList";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "../../components/general/spinner";
import "./style.css";

import { FormattedMessage } from "react-intl";

const CustomersListView = props => {
  const {    
    pageRef
  } = props;

  const main = useSelector(state => state.main);
  const studio = useSelector(state => state.studio.list);
  const customers = useSelector(state => state.customers.customersList);
  const dispatch = useDispatch();

  //   fatto per ottimizzare gli utenti che hanno tanti clienti.
  // useEffect(() => {
  //   if (
  //     accountantUuidSelected === customers.accountantUuidSelected &&
  //     customers.data
  //   ) {
  //     return;
  //   }
  //   dispatch(getCustomersList(auth, accountantUuidSelected));
  // }, [accountantIdSelected]);

  useEffect(() => {
    dispatch(getCustomersList());
  }, []);

  const ragioneSociale =
    main.accountantUuidSelected && studio
      ? studio.find(el => {
        return el.uuid === main.accountantUuidSelected;
      }).ragioneSociale
      : "";
  return (
    <Page
      pageRef={pageRef}      
      className="contentStructure"
      title={<FormattedMessage id="customers.title" />}
      subtitle={ragioneSociale}
      backText={<FormattedMessage id="deadlines.goBack" />}
      backUrl="/"
      activePage={"/"}
    >
      {!customers.data &&
        customers.status.started &&
        !customers.status.ended && <Spinner size="large" myClass="customers" />}
      {customers.data && customers.status.ended && (
        <React.Fragment>
          <div className={"allCustomersTitle"}>
            <FormattedMessage id="customersWidget.allCustomers" />
          </div>

          <CustomersList
            customers={customers.data}
            accountantIdSelected={main.accountantIdSelected}            
          />
        </React.Fragment>
      )}
    </Page>
  );
};

export default CustomersListView;
